import React from 'react'
import "../Explore/Explore.css"
import ExploreBanner from './ExploreBanner'
import InnovativeTechnology from './InnovativeTechnology'
import NFCbusinessCard from './NFCbusinessCard'
import WhatWeOffer from './WhatWeOffer'
import MarketingGrowth from './MarketingGrowth'
import ExploreBusinessRewards from './ExploreBusinessRewards'
import PromoteMembersBusinesses from './PromoteMembersBusinesses'
import ReferEarnProgram from './ReferEarnProgram'
import SeoGeneral from '../BusinessPage/SeoGeneral';

const Explore = () => {
  const seoMetaData = {
    title: "Explore NeooSearch – Innovative Technology & Business Solutions",
    description: "Discover NeooSearch's innovative technology and business solutions. Explore our NFC business cards, marketing growth strategies, and rewards programs designed to elevate your business.",
    ogImage: "https://neoosearch.com/static/media/Admin_chat%20logo.7fa36f039461d205a125.png",
    ogImageAlt: "Explore NeooSearch",
    url: process.env.REACT_APP_APPLICATION_URL + "/explore",
    keywords: "NeooSearch, explore, innovative technology, business solutions, NFC business cards, marketing growth, business rewards, promote businesses, refer and earn",
    type: "website",
    site_name: "NeooSearch",
    canonical: process.env.REACT_APP_APPLICATION_URL + "/explore"
  };

  return (
    <>
      <SeoGeneral data={seoMetaData} />
      <ExploreBanner />
      <InnovativeTechnology />
      <NFCbusinessCard />
      <WhatWeOffer />
      <MarketingGrowth />
      <ExploreBusinessRewards />
      <PromoteMembersBusinesses />
      <ReferEarnProgram />
    </>
  )
}

export default Explore